


























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter, namespace } from "vuex-class";
import StatCard from "@/components/StatCard.vue";
import TrendChart from "@/components/TrendChart.vue";
import TimeChart from "@/components/TimeChart.vue";
import GenderRatioChart from "@/components/GenderRatioChart.vue";
import {
  mdiBedSingle,
  mdiAccountGroup,
  mdiCurrencyUsd,
  mdiBusAlert,
} from "@mdi/js";

@Component({
  components: {
    StatCard,
    TrendChart,
    TimeChart,
    GenderRatioChart,
  },
})
export default class StatTableIterator extends Vue {
  @(namespace("dashboard").Getter("statsData")) getterStatData: any;
  search: string = "";
  bedIcon: string = mdiBedSingle;
  groupIcon: string = mdiAccountGroup;
  moneyIcon: string = mdiCurrencyUsd;
  carIcon: string = mdiBusAlert;

  // itemsPerPage: any = 5;

  tmpItems: any = [
    {
      title: "Practices",
      value: "3,256",
      icon: this.bedIcon,
      iconColor: "rgba(102, 45, 201, 1)",
    },
    {
      title: "Procedures",
      value: "394",
      icon: this.groupIcon,
      iconColor: "rgba(55, 173, 246, 1)",
    },
    {
      title: "Patients",
      value: "$2,536",
      icon: this.moneyIcon,
      iconColor: "rgba(255, 127, 93, 1)",
    },
    // {
    //   title: "Available Cars",
    //   value: "35",
    //   icon: this.carIcon,
    //   iconColor: "rgba(255, 67, 118, 1)",
    // },
  ];

  get items() {
    return this.getterStatData
      ? this.getterStatData.map((v: any) => ({ ...v, name: v.title }))
      : this.tmpItems;
  }
}
